export default "__VITE_ASSET__Dsi2Js_E__"